export const NoCustomers = ({ className }: { className?: string }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path
      d="M51.7999 31.3621V54C51.7999 54 50.8149 54 49.5999 54H14.4C13.185 54 12.2 54 12.2 54V31.3621L10 31.3621V10.8195L11.4998 9.5H52.9998L53.9999 10.8195V31.3621C53.9999 31.3621 53.9999 31.3621 51.7999 31.3621ZM35.9998 28.8564V25L36.9998 24C38.2148 24 39.9998 24 39.9998 24L41.075 25V28.8564C43.5051 28.8564 49.5999 28.8564 49.5999 28.8564L49.5999 14.6457H14.4L14.4 28.8564C14.4 28.8564 16.37 28.8564 18.8 28.8564C21.2301 28.8564 22.925 28.8564 22.925 28.8564V24.5L23.9998 23.9371L26.9998 23.9371L27.875 24.5V28.8564H35.9998Z"
      fill="#B2ABAB"
    />
  </svg>
);
